import { PATH_ROUTES } from 'routes/path';
import { InAppNotification } from 'types/notifications';

import FaceScan from 'assets/images/notifications/face_scan_reminder.png';
import VoiceScan from 'assets/images/notifications/voice_scan_reminder.png';
import PersonalisedReport from 'assets/images/notifications/personalised_report_reminder.png';
import LabReport from 'assets/images/notifications/lab_report_reminder.png';
import SymptomChecker from 'assets/images/notifications/symptom_checker_reminder.png';
import RiskChecker from 'assets/images/notifications/risk_checker_reminder.png';
import CompleteHealthProfile from 'assets/images/notifications/complete_health_profile_reminder.png';
import AddProfile from 'assets/images/notifications/add_a_profile_reminder.png';
import Misc from 'assets/images/notifications/misc_custom_reminder.png';

export const NotificationRoutes = {
  [InAppNotification.FACE_SCAN]: PATH_ROUTES.START_VOICE_SCAN,
  [InAppNotification.VOICE_SCAN]: PATH_ROUTES.START_VOICE_SCAN,
  [InAppNotification.PERSONALISED_REPORT]: PATH_ROUTES.GENERATE_AI_REPORT,
  [InAppNotification.LAB_REPORT]: PATH_ROUTES.GENERATE_LAB_REPORT,
  [InAppNotification.SYMPTOM_CHECKER]: PATH_ROUTES.GENERATE_SYMPTOM_CHECKER,
  [InAppNotification.RISK_CHECKER]: PATH_ROUTES.GENERATE_SYMPTOM_CHECKER,
  [InAppNotification.COMPLETE_HEALTH_PROFILE]: PATH_ROUTES.PROFILE,
  [InAppNotification.ADD_PROFILE]: PATH_ROUTES.ADD_MEMBER,
  [InAppNotification.FAMILY_MEMBER]: PATH_ROUTES.ADD_MEMBER,
  [InAppNotification.MISC]: PATH_ROUTES.ADD_MEMBER,
};

export const NotificationData = {
  [InAppNotification.FACE_SCAN]: {
    image: FaceScan,
    route: NotificationRoutes[InAppNotification.FACE_SCAN],
  },
  [InAppNotification.VOICE_SCAN]: {
    image: VoiceScan,
    route: NotificationRoutes[InAppNotification.VOICE_SCAN],
  },
  [InAppNotification.PERSONALISED_REPORT]: {
    image: PersonalisedReport,
    route: NotificationRoutes[InAppNotification.PERSONALISED_REPORT],
  },
  [InAppNotification.LAB_REPORT]: {
    image: LabReport,
    route: NotificationRoutes[InAppNotification.LAB_REPORT],
  },
  [InAppNotification.SYMPTOM_CHECKER]: {
    image: SymptomChecker,
    route: NotificationRoutes[InAppNotification.SYMPTOM_CHECKER],
  },
  [InAppNotification.RISK_CHECKER]: {
    image: RiskChecker,
    route: NotificationRoutes[InAppNotification.RISK_CHECKER],
  },
  [InAppNotification.COMPLETE_HEALTH_PROFILE]: {
    image: CompleteHealthProfile,
    route: NotificationRoutes[InAppNotification.COMPLETE_HEALTH_PROFILE],
  },
  [InAppNotification.ADD_PROFILE]: {
    image: AddProfile,
    route: NotificationRoutes[InAppNotification.ADD_PROFILE],
  },
  [InAppNotification.FAMILY_MEMBER]: {
    image: AddProfile,
    route: NotificationRoutes[InAppNotification.FAMILY_MEMBER],
  },
  [InAppNotification.MISC]: {
    image: Misc,
    route: NotificationRoutes[InAppNotification.MISC],
  },
};
